import reducers from './reducers';

const commonModule = {
  reducers: {
    common: reducers.mainLayoutAppearance,
    dimensions: reducers.dimensions,
    pagination: reducers.pagination,
    blockingDialogs: reducers.blockingDialogs,
    featureFlags: reducers.featureFlags,
    configParameters: reducers.configParameters,
    referrals: reducers.referrals,
  }
};

export default commonModule;
